<template>
  <v-card 
    class="mx-auto"
    max-width="344"
  >
    <v-card-text v-if="!loading">
      <v-text-field
        v-model="user.id"
        label="Χαρακτηριστικό (Id)"
        disabled
      ></v-text-field>

      <v-text-field
        v-model="user.userName"
        :disabled="!canEdit"
        label="Όνομα Χρήστη"
      ></v-text-field>

      <v-text-field
        v-model="user.email"
        :disabled="!canEdit"
        label="Email"
      ></v-text-field>

      <v-checkbox
        v-model="user.isAdmin"
        :disabled="!(canEdit && this.$store.state.user.id != user.id)"
        label="Διαχειριστής"
      ></v-checkbox>

      <v-checkbox
        v-model="user.isCampMaster"
        :disabled="!canEdit"
        label="Χειριστής Περιοχών Ευθύνης"
      ></v-checkbox>

      <CampPicker :camps="user.camps" :disabled="!canEdit" ref="campPicker"/>

      <v-text-field
        v-model="user.password"
        :disabled="!canEdit"
        label="Κωδικός"
        type="password"
      ></v-text-field>
    </v-card-text>

    <v-spacer></v-spacer>

    <p class="font-weight-regular" style="color: red;">
      {{ error }}
    </p>

    <v-card-actions>
          <v-btn
            color="blue"
            :disabled="!canEdit"
            :loading="loading"
            @click="save"
          >ΑΠΟΘΗΚΕΥΣΗ ΑΛΛΑΓΩΝ</v-btn>

          <v-dialog
            v-model="dialog"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!canEdit"
              :loading="loading"
              v-bind="attrs"
              v-on="on"
              color="red"
              class="ml-2"
            >ΔΙΑΓΡΑΦΗ</v-btn>
            </template>

            <v-card>
              <v-card-title>
                Επιβεβαίωση
              </v-card-title>

              <v-card-text>
                  Είστε σίγουρος πως θέλετε να διαγράψετε τον χρήστη;
                  Αυτή η ενέργεια δεν είναι αναστρέψιμη
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red"
                  @click="deleteUser"
                >
                  Ναι, ΔΙΑΓΡΑΦΗ.
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    </v-card-actions>

  </v-card>
</template>

<script>
import CampPicker from '@/components/CampPicker.vue'

export default {
  name: 'UserDetails',
  components: {
    CampPicker
  },
  props: {
    userId: {
      type: String,
      default: undefined,
      required: false
    },
    createNew: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => {
      return {
          loading: true,
          user: {
              id: "",
              password: "",
              email: "",
              userName: "",
              isCampMaster: false,
              isAdmin: false,
              camps: []
          },
          error: "",
          dialog: false
      }
  },
  async mounted() {
    if (this.createNew) {
      //const u = this.$store.state.user
      // if (!u.isAdmin && u.isCampMaster) {
      //   this.user.camps = u.camps
      // }

      this.loading = false
      return
    }
    await this.load()
  },
  watch: {
    userId: {
      handler: async function() {
        await this.load()
      }
    }
  },
  computed: {
        canEdit() {
          return this.$store.state.user.isAdmin || this.$store.state.user.isCampMaster
        }
    },
    methods: {
        async load(){
            this.loading = true
            try {
                const response = await this.$axios.get(`/users/${this.userId}`)
                this.user = Object.assign({}, this.user, response.data)

                this.error = ""
            } catch (e) {
                console.log(e.response.data)
                this.error = e.response.data
            }
            this.loading = false
        },
        async deleteUser() {
            this.loading = true
            try {
                await this.$axios.delete('/users/', { params: { id: this.userId } })
                this.error = `Ο χρήστης με χαρακτηρηστικό ${this.userId} διαγράφτηκε`

                // this.$router.replace('/admin/users')
            } catch (e) {
                console.log(e.response.data)
                this.error = e.response.data
            }
            this.loading = false
            this.dialog = false
        },
        async save() {
          const payload = {
            userName: this.user.userName,
            camps: this.$refs.campPicker.selectedCamps,
            email: this.user.email,
            isAdmin: this.user.isAdmin,
            isCampMaster: this.user.isCampMaster
          }

          console.log(payload)

          if (this.createNew && this.user.password.trim() === "") {
            this.error = "Παρακαλώ βάλτε έναν κωδικό"
            return
          }

          if (this.createNew || this.user.password.trim() != "") {
            payload.password = this.user.password
          }

          if (!this.createNew) {
            payload.id = this.userId
          }

          try {
            const response = await this.$axios.put('/users/', payload)
            if (this.createNew) {
              const newUserId = response.data
              this.$router.replace(`/users/${newUserId}`)
              this.userId = response.data
            }
          } catch (e) {
              console.log(e.response.data)
              this.error = e.response.data
              return
          }
          await this.load()
        }
    }
}
</script>
